import { render, staticRenderFns } from "./ShareLinks.vue?vue&type=template&id=792dade8&scoped=true&"
import script from "./ShareLinks.vue?vue&type=script&lang=js&"
export * from "./ShareLinks.vue?vue&type=script&lang=js&"
import style0 from "./ShareLinks.vue?vue&type=style&index=0&id=792dade8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792dade8",
  null
  
)

export default component.exports